import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppNotificationComponent } from './app-notification.component';
import { AppNotificationModel, AppNotificationType } from './app-notification.model';

@Injectable()
export class AppNotificationService {
    public constructor(private modalService: BsModalService) {}

    public setAppNotification(
        type: AppNotificationType,
        titleText: string,
        bodyText: string,
        okAction?: () => void,
    ): void {
        this.modalService.show(AppNotificationComponent, {
            backdrop: 'static',
            class: 'modal-md modal-fullscreen-md-down',
            initialState: {
                model: new AppNotificationModel(type, titleText, bodyText, okAction),
            },
            ariaLabelledBy: 'app-notification-modal-title',
        });
    }
}
